// src/components/chat/ChatItem.jsx
import React from 'react';
import ChatAvatar from '../../components/ChatAvatar';
import { formatChatTime } from '../../utils/formatters';
import LastMessagePreview from './LastMessagePreview';
import './ChatItem.css';

const ChatItem = ({
    chat,
    isActive,
    
    onClick,
    onContextMenu,
    onTouchStart,
}) => {
    return (
        <div
            className={`chat-item ${isActive ? 'active' : ''}`}
            onClick={onClick}
            onContextMenu={onContextMenu}
            onTouchStart={onTouchStart}
        >
            <div className="chat-avatar-wrapper">
                <ChatAvatar chat={chat} />
                {chat.type === 'private' && chat.is_online && (
                    <span className="online-indicator"></span>
                )}
            </div>

            <div className="chat-info">
                <div className="chat-header-row">
                    <div className={`chat-title ${chat.type === 'group' ? 'group-chat-title' : 'private-chat-title'}`}>
                        {chat.title}
                    </div>
                    <div className="chat-time">
                        {chat.last_message ? formatChatTime(chat.last_message.created_at) : ''}
                    </div>
                </div>
                <LastMessagePreview chat={chat} />
            </div>
        </div>
    );
};

export default ChatItem;